var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.setTheme()}}},[_c('v-icon',{staticClass:"medium-icon"},[_vm._v(_vm._s(_vm.$vuetify.theme.isDark == true ? 'mdi-lightbulb-on-outline' : 'fi fi-rr-moon'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }